import React from "react";
import RankingRow from "../../components/RankingRow";
import DoughnutChart from "../../components/charts/DoughnutChart";
import IndexMainChart from "../../components/charts/IndexMainChart";
import AdSenseBanner from "../../components/AdSenseBanner";
import { Button, Row, Col} from "react-bootstrap";
import { chartColors, links } from "../../utils/utils";


const electronic_group = ["半導體業", "電腦及週邊設備業", "光電業", "通信網路業", "電子零組件業", "電子通路業", "資訊服務業", "其他電子業"];
const chrimical_group = ["化學工業", "生技醫療業"]
const various_group = ["化學生技醫療", "電子工業"];

var date = [];
var twse_objs = [];

var all_labels = [];
var all_vols = [];

var electronic_labels = [];
var electronic_vols = []

function parseJsonData(data) {
    date = data['date'];
    let twse_labels = Object.keys(data['indexes']);
    let indexes = Object.values(data['indexes']);
    let vols = Object.values(data['vols']);
    let stock_list = data['stock_list'];

    let twse_today_vol = [];
    let twse_yesterday_vol = [];
    let today_index = vols[0].length - 1;
    let yesterday_index = today_index - 1;
    for (let i = 0; i < vols.length; i++) {
        twse_today_vol.push(parseFloat(vols[i][today_index]));
        twse_yesterday_vol.push(parseFloat(vols[i][yesterday_index]));
    }

    let today_sum = twse_today_vol.reduce((a, b) => a + b, 0);
    let todays_weight = twse_today_vol.map(x => (x * 100 / today_sum).toFixed(3));

    let yesterday_sum = twse_yesterday_vol.reduce((a, b) => a + b, 0);
    let yesterday_weight = twse_yesterday_vol.map(x => (x * 100 / yesterday_sum).toFixed(3));

    twse_objs = [];
    for (let i = 0; i < indexes.length; i++) {

        if (!electronic_group.includes(twse_labels[i]) && !chrimical_group.includes(twse_labels[i])) {  // except electronic_group and chrimical_group
            all_labels.push(twse_labels[i]);
            all_vols.push(twse_today_vol[i]);
        }

        if (electronic_group.includes(twse_labels[i])) {  // electronic_group for chart 2
            electronic_labels.push(twse_labels[i]);
            electronic_vols.push(twse_today_vol[i]);
        }

        if (various_group.includes(twse_labels[i]))  // except "化學生技醫療", "電子工業"
            continue;

        let weight_rise = 0;
        if (yesterday_weight[i] != 0) {
            weight_rise = ((todays_weight[i] - yesterday_weight[i]) * 100 / yesterday_weight[i]).toFixed(2);
        }

        let index_change = ((parseFloat(indexes[i][today_index]) - parseFloat(indexes[i][yesterday_index])) / parseFloat(indexes[i][yesterday_index]) * 100).toFixed(2);

        // console.log(twse_labels[i], stock_list[twse_labels[i]]);

        twse_objs.push({
            title: twse_labels[i],
            index: indexes[i],
            vol: vols[i],
            link: links.goodinfo_twse + twse_labels[i],
            index_change: index_change,
            weight: todays_weight[i],
            weight_rise: weight_rise,
            stock_list: stock_list[twse_labels[i]],
        });
    }
}

class TwseIndexPanel extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            filter: "weight_rise_rank",
        };
        parseJsonData(this.props.data);
    }

    handleClick(e) {
        this.setState({filter: e.target.value});
    }
    
    genDoughnutChartData(labels, data) {
        const bgcolor = [
            chartColors.teal,
            chartColors.orange2,
            chartColors.green,
            chartColors.red,
            chartColors.maroon,
            chartColors.aqua,
            chartColors.yellow,
            chartColors.lime,
            chartColors.silver,
            chartColors.aqua,
            chartColors.blue2,
            chartColors.blue,
            chartColors.navy,
            chartColors.fuchsia,
            chartColors.yellow2,
            chartColors.purple,
            chartColors.red2,
            chartColors.orange,
            chartColors.green2,
            chartColors.silver,
            chartColors.red,
            chartColors.maroon,
            chartColors.teal2,
            chartColors.orange2,
            chartColors.yellow,
            chartColors.lime,
            chartColors.green2,
            chartColors.aqua
        ];

        return({
            labels: labels,
            datasets: [{
                data: data,
                backgroundColor: bgcolor,
                label: 'dataset'
            }]
        });
    }

    genSubChartData(date, main_data, main_title, sub_data, sub_title, index_change) {
        return ({
            labels: date,
            datasets: [{
                type: 'line',
                label: main_title,
                data: main_data,
                borderColor: index_change < 0 ? chartColors.green : chartColors.red,
                borderWidth: 2,
                fill: false,
                yAxisID: 'y-axis-1'
            }, {
                type: 'bar',
                label: sub_title,
                data: sub_data,
                backgroundColor: chartColors.silver,
                borderWidth: 2,
                yAxisID: 'y-axis-2'
            }]
        });
    }

    genSubChartData2(date, main_data, main_title, sub_data, sub_title) {
        return ({
            labels: date,
            datasets: [{
                type: 'line',
                label: main_title,
                data: main_data,
                borderColor: chartColors.teal,
                borderWidth: 2,
                fill: false,
                yAxisID: 'y-axis-1'
            }, {
                type: 'line',
                label: sub_title,
                data: sub_data,
                borderColor: chartColors.orange,
                borderWidth: 2,
                fill: false,
                yAxisID: 'y-axis-1'
            }]
        });
    }

    genIndexMainChartData(labels, index_change, weight, title) {
        if (weight.length === 0) {
            return ({
                labels: labels,
                datasets: [{
                    type: 'bar',
                    label: "指數漲幅",
                    data: index_change,
                    backgroundColor: chartColors.blue,
                    borderWidth: 2,
                    yAxisID: 'y-axis-1'
                }]
            });
        } else {
            return ({
                labels: labels,
                datasets: [{
                    type: 'bar',
                    label: "指數漲幅",
                    data: index_change,
                    backgroundColor: chartColors.blue,
                    borderWidth: 2,
                    yAxisID: 'y-axis-1'
                }, {
                    type: 'bar',
                    label: title,
                    data: weight,
                    backgroundColor: chartColors.grey,
                    borderWidth: 2,
                    yAxisID: 'y-axis-2'
                }]
            });
        }
    }
 
    renderRankingList() {
        let date_no_year = date.map(d => d.substring(5));
        let rankingList = [];
        for (let i = 0; i < twse_objs.length; i++) {
            let chart_data = this.genSubChartData(date_no_year, twse_objs[i].index, twse_objs[i].title, twse_objs[i].vol, "成交量", twse_objs[i].index_change);
            let title = (i+1).toString() + ". " + twse_objs[i].title;
            let subtitle = "指數漲幅%:" + twse_objs[i].index_change + " 成交比重%:" + twse_objs[i].weight + " 成交比重增幅%:" + twse_objs[i].weight_rise;
            rankingList.push(
                <RankingRow key={twse_objs[i].title} chart_data={chart_data} title={title} subtitle={subtitle} addr={twse_objs[i].link} stock_list={twse_objs[i].stock_list} />
            );
        }
        return rankingList;
    }

    render() {
        console.log("render");

        let filter = this.state.filter;
        let title = "", label = [], index_change = [], weight = [];
        switch (filter) {
            case 'index_rank':
                twse_objs.sort(function (a, b) {
                    return b.index_change - a.index_change;
                });
                for (let i = 0; i < twse_objs.length; i++) {
                    label.push(twse_objs[i].title);
                    index_change.push(twse_objs[i].index_change);
                }
                break;
            case 'weight_rank':
                twse_objs.sort(function (a, b) {
                    return b.weight - a.weight;
                });
                title = "成交比重";
                for (let i = 0; i < twse_objs.length; i++) {
                    label.push(twse_objs[i].title);
                    index_change.push(twse_objs[i].index_change);
                    weight.push(twse_objs[i].weight);
                }
                break;
            case 'weight_rise_rank':
                twse_objs.sort(function (a, b) {
                    return b.weight_rise - a.weight_rise;
                });
                title = "成交比重增幅";
                for (let i = 0; i < twse_objs.length; i++) {
                    label.push(twse_objs[i].title);
                    index_change.push(twse_objs[i].index_change);
                    weight.push(twse_objs[i].weight_rise);
                }
                break;
            default:
                console.log("unknown");
        }

        return (
            <div className="container">
                <div>
                    <h4>{this.props.data.info.date}</h4>
                    <Row className="mb-5">
                        <Col sm>
                            <DoughnutChart data={this.genDoughnutChartData(all_labels, all_vols)} title="上市類股成交金額分佈" />
                         </Col>
                         <Col sm>
                            <DoughnutChart data={this.genDoughnutChartData(electronic_labels, electronic_vols)} title="電子上市類股成交金額分佈" />
                         </Col>
                     </Row>
                </div>

                <div>
                    <h6>上市類股金流分佈</h6>
                    <p>觀察每日類股指數與成交比重增幅排名, 成交比重異常增加, 指數無明顯變化, 表示已有資金提前進入或撤出該類股.<br />
                        點擊類股名稱, 觀察類股成分, 分析該類股前幾大個股, 搭配法人籌碼, 基本面, 技術面等伺機佈局.
                    </p>
                </div>

                <hr />
                <AdSenseBanner />
                <div className="mr-auto mb-2">
                    <Button variant="primary" className="mr-2" size="sm" onClick={this.handleClick} value="index_rank">指數漲幅排名</Button>
                    <Button variant="primary" className="mr-2" size="sm" onClick={this.handleClick} value="weight_rank">成交比重排名</Button>
                    <Button variant="primary" className="mr-2" size="sm" onClick={this.handleClick} value="weight_rise_rank">成交比重增幅排名</Button>
                </div>
                <div>
                    <IndexMainChart data={this.genIndexMainChartData(label, index_change, weight, title)} title="電子金融比例"/>
                </div>

                {this.renderRankingList()}

            </div>
        )
    }
}

export default TwseIndexPanel